import type { ViewType } from 'owa-calendar-actions';
import type { NotificationBarHostId } from 'owa-notification-bar';

/**
 * Determines the ID of the NotificationBarHost that will show the notification.
 *
 * Fallbacks to default NotificationBarHost for the Calendar module
 */
export default function getNotificationBarHostId(actionSource: ViewType): NotificationBarHostId {
    if (
        actionSource === 'TimePanelCalendar' ||
        actionSource === 'TimePanelPeek' ||
        actionSource === 'TimePanelContextMenu' ||
        actionSource === 'TimePanelCompose'
    ) {
        return 'TimePanelNotificationBarHost';
    } else {
        return 'CalendarModuleNotificationBarHost';
    }
}
